if (!customElements.get('the-fold-video')) {
  customElements.define('the-fold-video', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      if (!video || !button) return;
      button.addEventListener('click', async () => {
        button.disabled = true;
        status.hidden = true;
        this.setAttribute('data-playing', '');
        video.controls = true;
        try {
          await video.play();
          video.focus();
        } catch {
          this.removeAttribute('data-playing');
          status.hidden = false;
        } finally {
          button.disabled = false;
          if (!this.hasAttribute('data-playing')) button.focus();
        }
      }, { signal: this.controller.signal });
      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting && !this.getClientRects().length) video.pause();
      });
      this.visibilityObserver.observe(this);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.visibilityObserver?.disconnect();
      this.querySelector('video')?.pause();
    }
  });
}
